import { Category } from '../types';

// Mock categories data
export const categories: Category[] = [
  {
    id: '1',
    name: 'Handwoven Textiles',
    description: 'Sarees, scarves, and fabrics woven with heritage techniques',
    image: '/images/products/Whisk_storyboarde3d063b7068249a38d4a80ec.png',
    productCount: 15420,
    featured: true,
    regions: ['Rajasthan', 'Gujarat', 'West Bengal']
  },
  {
    id: '2',
    name: 'Traditional Jewelry',
    description: 'Kundan, Meenakari, and silver jewelry by master craftsmen',
    image: '/images/products/Whisk_storyboard861b54c63f8f432ca5c9113a.png',
    productCount: 8965,
    featured: true,
    regions: ['Rajasthan', 'Punjab', 'Assam']
  },
  {
    id: '3',
    name: 'Ceramics & Pottery',
    description: 'Blue pottery, terracotta, and ceramic art pieces',
    image: '/images/products/Whisk_storyboardcf823d9988de48188b9197a0.png',
    productCount: 6234,
    featured: true,
    regions: ['Gujarat', 'Rajasthan', 'Himachal Pradesh']
  },
  {
    id: '4',
    name: 'Wooden Crafts',
    description: 'Carved sculptures, furniture, and decorative items',
    image: '/images/products/Whisk_storyboard6ed87fdba0b64823adeee3f1.png',
    productCount: 4821,
    featured: true,
    regions: ['Kashmir', 'Karnataka', 'Kerala']
  },
  {
    id: '5',
    name: 'Metal Crafts',
    description: 'Brass work, copper items, and metallic art pieces',
    image: '/images/products/Whisk_storyboardf4d98aa2593c430da081f1f6.png',
    productCount: 3567,
    featured: false,
    regions: ['Uttar Pradesh', 'Bihar', 'West Bengal']
  },
  {
    id: '6',
    name: 'Leather Goods',
    description: 'Handcrafted bags, shoes, and leather accessories',
    image: '/images/products/Whisk_storyboarda0fcf97e56b44232aafa952a.png',
    productCount: 2843,
    featured: false,
    regions: ['Uttar Pradesh', 'Tamil Nadu', 'Maharashtra']
  }
];